import { Label } from "../ui/label";
import { Button } from "../ui/button";
import LoadingButton from "../LoadingButton";
import { Input } from "../ui/input";
import { useState } from "react";
import {
  Toast,
  ToastDescription,
  ToastTitle,
  ToastViewport,
} from "../ui/toast";

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL

const SetResinCost = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [toastList, setToastList] = useState([]);

  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const credentials = `${username}:${password}`;
  const encodedCredentials = btoa(credentials); // Base64 encode the credentials

  const [resinCost, setResinCost] = useState({
    R320: "",
    R330: "",
    R325: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setResinCost((prev) => ({
      ...prev,
      [id]: value, // Dynamically update the corresponding key
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const token = localStorage.getItem("x-auth-token");
      //   console.log(token);
      const response = await fetch(`${API_URL}/api/resin-cost`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
        body: JSON.stringify(resinCost),
      });

      const responseData = await response.json();

      if (response.ok) {
        setToastList((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "SUCCESS!",
            description: responseData.data?.message || "!",
            variant: "default",
          },
        ]);

        setIsLoading(false);
      } else {
        setToastList((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "SUCCESS!",
            description: responseData.data?.message || "!",
            variant: "default",
          },
        ]);
        // console.error("Failed to update cost:", responseData.error);

        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error updating cost:", error);
      setIsLoading(false);
    }
  };

  const removeToast = (id) => {
    setToastList((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <main className="tw-p-8">
      <form onSubmit={handleSubmit}>
        <div className="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8">
          <div className="tw-grid tw-gap-2">
            <Label className="tw-font-medium" htmlFor="R320">
              Portable Water R320
            </Label>
            <Input
              className="placeholder:tw-text-[#828282]/50 placeholder:tw-text-xs no-spin tw-bg-white placeholder:md:tw-text-sm"
              id="R320"
              type="number"
              value={resinCost.R320}
              onChange={handleInputChange}
              placeholder="Enter new cost"
              required
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault(); // Prevent increment/decrement
                }
              }}
            />
          </div>

          <div className="tw-grid tw-gap-2">
            <Label className="tw-font-medium" htmlFor="R330">
              Waste Water R330
            </Label>
            <Input
              className="placeholder:tw-text-[#828282]/50 placeholder:tw-text-xs no-spin tw-bg-white placeholder:md:tw-text-sm"
              id="R330"
              type="number"
              value={resinCost.R330}
              onChange={handleInputChange}
              placeholder="Enter new cost"
              required
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault(); // Prevent increment/decrement
                }
              }}
            />
          </div>

          <div className="tw-grid tw-gap-2">
            <Label className="tw-font-medium" htmlFor="R375">
              Industrial R325
            </Label>
            <Input
              className="placeholder:tw-text-[#828282]/50 placeholder:tw-text-xs no-spin tw-bg-white placeholder:md:tw-text-sm"
              id="R325"
              type="number"
              value={resinCost.R325}
              onChange={handleInputChange}
              placeholder="Enter new cost"
              required
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault(); // Prevent increment/decrement
                }
              }}
            />
          </div>
        </div>

        {isLoading ? (
          <LoadingButton />
        ) : (
          <Button
            type="submit"
            className="tw-w-full tw-font-semibold tw-mt-6 md:tw-mt-8 tw-text-sm"
          >
            CONFIRM
          </Button>
        )}
      </form>

      {/* Toast Notifications */}
      <ToastViewport />
      {toastList.map(({ id, title, description, variant }) => (
        <Toast
          key={id}
          variant={variant}
          open={true}
          duration={Infinity}
          onOpenChange={(isOpen) => {
            if (!isOpen) removeToast(id);
          }}
          className="tw-flex tw-flex-col tw-text-center"
        >
          <ToastTitle>{title}</ToastTitle>
          <ToastDescription>{description}</ToastDescription>

          {/* Close Button */}
          <button
            onClick={() => removeToast(id)}
            className="tw-mt-3 tw-self-center tw-text-sm tw-font-medium tw-bg-white tw-px-2 tw-py-1 tw-text-black hover:tw-bg-white/80"
          >
            Close
          </button>
        </Toast>
      ))}
    </main>
  );
};

export default SetResinCost;
